import React from 'react';
import { Grid, Typography, Button } from '@mic3/platform-ui';
import styled from 'styled-components';

import ModalDialog from 'app/components/organisms/ModalDialog/ModalDialog';
import Link from 'app/components/atoms/Link/Link';

const LinkStyled = styled(Link)`
    color: ${({ theme }) => theme.color.primary};
`;

const EntityListAttributeBJModal = ({ jobId, onClose }) => {
    return (
        <ModalDialog title="Your execution is being prepared" bgcolor={'rgba(40, 51, 75, 1)'} withoutClose>
            <Typography>
                Your execution of action is being prepared for you.
                {jobId ? (
                    <>
                        {' '}
                        When completed the result will be available <LinkStyled to={`/abox/background-job/${jobId}/logs`}>here</LinkStyled> or
                    </>
                ) : null}{' '}
                you can find it under <LinkStyled to="/abox/background-jobs">Background Jobs</LinkStyled> in A-Box.
            </Typography>
            <Grid container justify="flex-end">
                <Button variant="text" onClick={onClose}>
                    i understand
                </Button>
            </Grid>
        </ModalDialog>
    );
};

export default EntityListAttributeBJModal;